module.exports = __webpack_public_path__ + "static/media/6COPUOS1.37d4dd6a.jpg";